export default "__VITE_ASSET__DkMC51zW__"